import React, { useEffect, useState } from "react";
import "../styles/deals.css";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeals();
  }, []);

  async function fetchDeals() {
    try {
      const q = query(
        collection(db, "deals"),
        orderBy("createdAt", "desc") // 🔥 latest first
      );

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setDeals(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  function formatDate(date) {
  if (!date) return "";

  // 🔥 Firestore Timestamp support
  if (date.seconds) {
    date = new Date(date.seconds * 1000);
  }

  const d = new Date(date);

  if (isNaN(d)) return "";

  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short"
  });
}

  if (loading) return <div className="loading">Loading deals...</div>;

  return (
    <div className="deals-page">
      <div className="deals-header">
  <h1>AMAZON DEALS</h1>
  <p>Best offers curated for you</p>
</div>

      <div className="deals-grid">
        {deals.map(item => (
          <div className="deal-card" key={item.id}>
  
  {/* TAG */}
  <span className="tag">{item.tag}</span>

  {/* DISCOUNT */}
  {item.discount > 0 && (
    <span className="discount">-{item.discount}%</span>
  )}

  {/* IMAGE */}
  <img src={item.image} alt={item.title} />

  <div className="deal-card-content">
    
    <h3>{item.title}</h3>

    <div className="price">
      ₹{item.price}
      {item.oldPrice > 0 && (
        <span className="old">₹{item.oldPrice}</span>
      )}
    </div>

    {/* DATE */}
    <div className="date">
      {formatDate(item.createdAt)}
    </div>

    <a href={item.url} target="_blank" rel="noopener noreferrer">
      Buy Now
    </a>

  </div>
</div>
        ))}
      </div>
    </div>
  );
}